"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ServiceIds = void 0;
var ServiceIds;
(function (ServiceIds) {
    ServiceIds["InspectionApp"] = "est-inspection-app";
    ServiceIds["PolicyholderApp"] = "est-policyholder-app";
    ServiceIds["Portal"] = "est-claim-handler-portal";
    ServiceIds["IntegrationAPI"] = "est-integration-api";
    ServiceIds["NTEP"] = "est-ntep";
    ServiceIds["Simulation"] = "est-simulation";
    ServiceIds["Postman"] = "est-postman";
    ServiceIds["APITools"] = "est-api-tools";
})(ServiceIds = exports.ServiceIds || (exports.ServiceIds = {}));
//# sourceMappingURL=service-ids.js.map